// src/holladai/services/inventoryStatsService.js
import { supabase } from "../../supabaseClient";

export async function fetchInventoryStats(hotelIds = [], startDate, endDate) {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session) throw new Error("User not logged in");

  const token = session.access_token;
  const results = {};

  for (let hotelId of hotelIds) {
    // Build query params
    const params = new URLSearchParams({ hotelId: hotelId.toString() });
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const res = await fetch(
      `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/ohip-inventory-stats?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Inventory stats fetch failed for ${hotelId}: ${text}`);
    }

    const rawData = await res.json();

    // Just return the raw hotel object (with dailyOccupancy)
    results[hotelId] = rawData[hotelId] ?? rawData;
  }

  return results;
}
